import CropImageHandler from './CropImageHandler';

export default CropImageHandler;
